import { createAsyncThunk } from '@reduxjs/toolkit';
import { ax } from 'services/apiService';

export const saveEvent = createAsyncThunk('save-event', async (payload: any, { rejectWithValue }) => {
    try {
        const { data } = await ax.post(`service_request/banner_notification`, payload);
        // store user's token in local storage
        return data;
    } catch (error: any) {
        // return custom error message from API if any
        if (error.response && error.response.data) {
            return rejectWithValue(error.response.data);
        } else {
            return rejectWithValue(error.response.data);
        }
    }
});

export const getEvent = createAsyncThunk('get-event', async (payload: any, { rejectWithValue }) => {
    try {
        const { data } = await ax.post(`service_request/get_bannerinfo`,payload);
        // store user's token in local storage
        return data;
    } catch (error: any) {
        // return custom error message from API if any
        if (error.response && error.response.data) {
            return rejectWithValue(error.response.data);
        } else {
            return rejectWithValue(error.response.data);
        }
    }
});
// service_request/delete_bannerinfo/1
export const deleteEvent = createAsyncThunk('delete-event', async (id: any, { rejectWithValue }) => {
    try {
        const { data } = await ax.get(`service_request/delete_bannerinfo/${id}`);
        // store user's token in local storage
        return data;
    } catch (error: any) {
        // return custom error message from API if any
        if (error.response && error.response.data) {
            return rejectWithValue(error.response.data);
        } else {
            return rejectWithValue(error.response.data);
        }
    }
});
